import { createFileRoute } from '@tanstack/react-router';

// Fiche ouverte : la mise en page `_carte` lit l'identifiant et garde les filtres, la vue et le cadrage
// de l'écran d'où l'on vient, sans remonter la carte.
export const Route = createFileRoute('/_carte/clients/$id')({});
